import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { GrayPara, QuoteIdContainer } from "../../QuoteList.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import "../../QuoteList.scss";

const SiteInfo = (props) => {
  const { t, data, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive !== 5 ? 1 : "0.2"}>
        <QuoteIdContainer>
          <Link
            className="quote-listing__list-link"
            to={`/site/view/${data.siteId}/general-info`}
          >
            {"#" + data.siteId + " " + data.siteName}
          </Link>
        </QuoteIdContainer>
        <QuoteIdContainer>
          <GrayPara fontSize="14px">{data.companyName} </GrayPara>
        </QuoteIdContainer>
      </DivBackgroundOpacity>
    </>
  );
};

SiteInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SiteInfo);
